import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { BotRunListStore } from "../../store/BotRunListStore";

type BotRunListDialogsProps = {
  store: BotRunListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de BotRun.
 * Separado para mantener BotRunListPage más limpio.
 */
export const BotRunListDialogs: React.FC<BotRunListDialogsProps> = observer(
  ({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />

        {/* Dialog de confirmación de borrado individual: mientras consulta si se
          puede borrar, el Ok espera; si el registro está en uso, dice por qué y
          solo ofrece Cerrar. */}
        <ConfirmCancelDialog
          open={store.confirmDeleteDialogOpened}
          title={store.confirmDeleteTitle}
          description={store.confirmDeleteDescription}
          onConfirm={() =>
            store.deleteCheck === "blocked"
              ? store.closeConfirmDeleteDialog()
              : store.confirmOkDelete()
          }
          onCancel={() => store.closeConfirmDeleteDialog()}
          onClose={() => store.closeConfirmDeleteDialog()}
          confirmLabel={
            store.deleteCheck === "blocked" ? langStore.closeCommand : undefined
          }
          hideCancelButton={store.deleteCheck === "blocked"}
          confirmDisabled={
            store.deleteCheck === "checking" || store.deleteCheck === "deleting"
          }
          cancelDisabled={
            store.deleteCheck === "deleting" && !store.deleteStuck
          }
        />

        {/* Dialog de confirmación de borrado múltiple */}
        <ConfirmCancelDialog
          open={store.confirmMultiDeleteDialogOpened}
          title={langStore.confirmMultiDeleteTitle(store.selectedRowIds.size)}
          description={store.confirmMultiDeleteDescription}
          onConfirm={() => store.confirmMultiDelete()}
          onCancel={() => store.closeMultiDeleteDialog()}
          onClose={() => store.closeMultiDeleteDialog()}
          confirmDisabled={store.multiDeleting}
          cancelDisabled={store.multiDeleting && !store.multiStuck}
        />
      </>
    );
  }
);
